<template>
  <div class="applied-list">
    <div>
      <el-form ref="refSearchForm" :model="queryParams" label-width="100px" inline>
        <el-form-item label="规格型号">
          <el-input v-model="queryParams.productModel" size="small"  placeholder="请输入规格型号"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParams.status" size="small" clearable placeholder="请选择状态">
            <el-option
                v-for="subItem in enumStatus"
                :key="subItem.value"
                :label="subItem.name"
                :value="subItem.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" round icon="el-icon-search" @click="getPageList()">搜索</el-button>
          <el-button round size="small" @click="onClickClear">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-loading="listLoading">
      <div v-if="tableData.length">
        <el-table
            :data="tableData"
            border>
          <el-table-column
              type="index"
              align="center"
              width="40">
          </el-table-column>
          <el-table-column
              prop="productName"
              show-overflow-tooltip
              align="center"
              label="产品名称"
              width="120">
          </el-table-column>
          <el-table-column
              prop="productCount"
              show-overflow-tooltip
              align="center"
              label="申请数量">
          </el-table-column>
          <el-table-column
              prop="productModel"
              show-overflow-tooltip
              align="center"
              label="规格型号">
          </el-table-column>
          <el-table-column
              prop="lotNumber"
              show-overflow-tooltip
              align="center"
              label="批号">
          </el-table-column>
          <el-table-column
              prop="orderNo"
              show-overflow-tooltip
              align="center"
              label="订单号">
          </el-table-column>
          <el-table-column
              prop="createDate"
              show-overflow-tooltip
              align="center"
              label="申请时间"
              width="180">
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button
                  :disabled="(scope.row.status==='REVIEW_PASS'||scope.row.status==='REVIEW')"
                  type="text" @click="onClickEdit(scope.row)">修改
              </el-button>
              <el-button
                  :disabled="!(scope.row.status==='REVIEW_PASS')"
                  type="text" @click="onClickPrint(scope.row)">打印
              </el-button>
              <el-button type="text" @click="onClickProduct(scope.row)">产品信息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 20px;"
            @current-change="onChangeCurrent($event,1)"
            :current-page="queryParams.current"
            :page-size="queryParams.pageSize"
            background
            layout="total, prev, pager, next"
            :total="queryParams.total">
        </el-pagination>
      </div>
      <div v-else style="text-align:center;margin:20px 0">
        <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
      </div>
    </div>
    <el-dialog
        class="dialog-code-box"
        append-to-body
        destroy-on-close
        title="产品信息模板选择"
        @close="onClickTemplateCancel"
        :visible="dialogTemplateVisible"
        width="1000px">
      <div class="dialog-info-box" v-if="dialogTemplateVisible">
        <el-form ref="refSearchForm" :model="dialogTemplateParams" label-width="100px" inline>
          <el-form-item label="模板名称">
            <el-input v-model="dialogTemplateParams.name" size="small" clearable
                      placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" size="small" round icon="el-icon-search" @click="getDialogTemplateList()">搜索
            </el-button>
            <el-button round size="small" @click="onClickDialogTemplateClear">重置</el-button>
          </el-form-item>
        </el-form>
        <div v-loading="dialogTemplateLoading">
          <div v-if="dialogTemplateData.length">
            <el-table
                row-key="uuid"
                :data="dialogTemplateData"
                @select-all="selectAll"
                @selection-change="handleSelectionChange"
                ref="refDialogTemplate"
                border>
              <el-table-column
                  type="selection"
                  align="center"
                  reserve-selection
                  width="45">
              </el-table-column>
              <el-table-column
                  type="index"
                  align="center"
                  width="40">
              </el-table-column>
              <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  align="center"
                  label="模板名称">
              </el-table-column>
              <el-table-column
                  prop="model"
                  show-overflow-tooltip
                  align="center"
                  label="适用型号">
              </el-table-column>
              <el-table-column
                  prop="productModel"
                  show-overflow-tooltip
                  align="center"
                  label="状态"
                  width="120">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status===1" type="success">
                    已发布
                  </el-tag>
                  <el-tag v-else type="info">
                    未发布
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  show-overflow-tooltip
                  align="center"
                  label="创建时间">
              </el-table-column>
              <!--              <el-table-column label="操作" align="center" width="60">-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-button type="text" @click="onClickView(scope.row)">查看</el-button>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
            </el-table>
            <el-pagination
                style="margin-top: 20px;"
                @current-change="onChangeCurrent($event,2)"
                :current-page="dialogTemplateParams.current"
                :page-size="dialogTemplateParams.pageSize"
                background
                layout="total, prev, pager, next"
                :total="dialogTemplateParams.total">
            </el-pagination>
          </div>
          <div v-else style="text-align:center;margin:20px 0">
            <img src="../../assets/nosearchMesg.jpg" alt="" style="width:200px">
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClickTemplateCancel">取 消</el-button>
        <el-button size="small" type="primary" :loading="dialogTemplateBoundLoading" @click="onClickTemplateSubmit">
          选 择
        </el-button>
      </span>
    </el-dialog>
    <product-info v-if="showInfo"/>
  </div>
</template>

<script>

import {getCodeTraceabilityList, getTemplateList, sendTemplateBound} from "../../utils/interface";
import ProductInfo from "./reversoProductInfo";

export default {
  components: {
    ProductInfo,
  },
  data() {
    return {
      showInfo: false,
      tableData: [],
      queryParams: {
        productModel: '',
        status: '',
        current: 1,
        pageSize: 5,
        total: 0,
        enterpriseUuid: this.$store.state.isUsermessage.uuid,
      },
      enumStatus: [{
        value: 'INIT',
        name: '未审核',
      }, {
        value: 'REVIEW',
        name: '待审核',
      }, {
        value: 'NOT_PASS',
        name: '审核不通过',
      }, {
        value: 'REVIEW_PASS',
        name: '审核通过',
      }, {
        value: 'FINISH',
        name: '已生成',
      },],
      listLoading: false,
      dialogTemplateVisible: false,
      dialogTemplateLoading: false,
      dialogTemplateBoundLoading: false,
      dialogRowData: {},
      dialogTemplateData: [],
      dialogMultipleTable: [],
      dialogTemplateParams: {
        name: '',
        model: '',
        current: 1,
        pageSize: 5,
        total: 0,
      },
    };
  },
  created() {

  },
  methods: {
    initData() {
      this.getPageList()
      this.getOptionsData()
    },
    getPageList() {
      this.listLoading = true
      getCodeTraceabilityList(this.queryParams).then((res) => {
        this.listLoading = false
        if (res.list) {
          this.tableData = res.list
          this.queryParams.total = res.total
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getOptionsData() {

    },
    onClickEdit(row) {
      this.$emit('onChangeType', 0, row)
    },
    onClickPrint(row) {
      this.$emit('onChangeStep', 4, row)
    },
    onClickProduct(row) {
      this.dialogRowData = row
      this.dialogTemplateVisible = true
      this.$nextTick(() => {
        this.getDialogTemplateList()
      })
    },
    getDialogTemplateList() {
      this.dialogTemplateLoading = true
      getTemplateList(this.dialogTemplateParams).then((res) => {
        this.dialogTemplateLoading = false
        if (res.list) {
          this.dialogTemplateData = res.list
          this.dialogTemplateParams.total = res.total
          if (this.dialogRowData && this.dialogRowData.explanationId && this.dialogTemplateData.length) {
            this.$nextTick(() => {
              //勾选回显
              let selectRow = this.dialogTemplateData.find(item => item.uuid === this.dialogRowData.explanationId)
              if (selectRow) {
                this.$refs.refDialogTemplate.clearSelection()
                this.$refs.refDialogTemplate.toggleRowSelection(selectRow, true)
              }
            })
          }
        }
      }).catch(err => {
        this.dialogTemplateLoading = false
      })
    },
    onClickDialogTemplateClear() {
      this.dialogTemplateParams = {
        name: '',
        model: '',
        current: 1,
        pageSize: 5,
        total: 0,
      }
      this.getDialogTemplateList()
    },
    onClickTemplateSubmit() {
      console.log(this.dialogRowData)
      console.log(this.dialogMultipleTable.name)
      this.dialogTemplateBoundLoading = true
      let data = {
        uuid: this.dialogRowData.uuid,
        explanationId: this.dialogMultipleTable.uuid,
      }
      sendTemplateBound(data).then((res) => {
        this.dialogTemplateBoundLoading = false
        this.$message({
          type: res.success ? "success" : "warning",
          message: res.success ? "绑定成功" : "绑定失败",
        })
        if (res.success) {
          this.onClickTemplateCancel()
        }
        this.getPageList()
      }).catch(err => {
        this.dialogTemplateBoundLoading = false
      })
    },
    onClickTemplateCancel() {
      this.dialogTemplateVisible = false
      this.dialogRowData = {}
      this.dialogTemplateData = []
      this.dialogMultipleTable = []
      this.dialogTemplateParams = {
        name: '',
        model: '',
        current: 1,
        pageSize: 5,
        total: 0,
      }
    },
    handleSelectionChange(selection) {
      this.$nextTick(() => {
        if (selection.length > 1) {
          this.$refs.refDialogTemplate.clearSelection()
          this.$refs.refDialogTemplate.toggleRowSelection(selection.pop())
        }
        if (selection[0]) {
          this.dialogMultipleTable = JSON.parse(JSON.stringify(selection[0]))
        }
      })
    },
    selectAll() {
      this.$refs.refDialogTemplate.clearSelection()
    },
    onClickClear() {
      this.$refs['refSearchForm'].resetFields()
      this.queryParams = {
        productModel: '',
        status: '',
        current: 1,
        pageSize: 5,
        total: 0,
      }
      this.getPageList()
    },
    onChangeCurrent(e, type) {
      if (type === 1) {
        this.queryParams.current = e
        this.getPageList()
      } else if (type === 2) {
        this.dialogTemplateParams.current = e
        this.getDialogTemplateList()
      }
    },
    eachDictName(status) {
      return this.enumStatus.find(item => item.value === status).name
    },
  },
};
</script>

<style scoped lang="less">
.applied-list {
  /deep/ .el-button--small.is-round {
    padding: 9px 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceabilityOther/reversoAppliedList.vue